import React from 'react';
import style from './style.module.scss';
import MajorViewList from '../../view/list';
import clsx from 'clsx';
import moment from 'moment';

const MajorTimeSortWrapper = ({
  page,
  sportsView,
  majorSelected,
  setSelectedGame,
  isFinal = false
}) => {
  let todayMatch = [];
  let tomorrowMatch = [];
  let tomorrowDate = '';
  const todayDate = moment().format('YYYY.MM.DD');

  sportsView.map((item) => {
    const { startDatetime } = item;
    const matchDateTime = moment(startDatetime).format('YYYY.MM.DD');

    if (todayDate !== matchDateTime) {
      tomorrowDate = matchDateTime;
      tomorrowMatch.push(
        <MajorViewList
          key={item.id}
          item={item}
          isSelected={majorSelected
            .filter((sel) => sel.sportsType === item.sportsType.toLowerCase())
            .some((id) => id.key === item.id)}
          setSelectedGame={setSelectedGame}
        />
      );
    } else {
      todayMatch.push(
        <MajorViewList
          key={item.id}
          item={item}
          isSelected={majorSelected
            .filter((sel) => sel.sportsType === item.sportsType.toLowerCase())
            .some((id) => id.key === item.id)}
          setSelectedGame={setSelectedGame}
        />
      );
    }
  });
  return [
    <div className={clsx(style.sportTypeWrapper, isFinal && style.final, page === 'home' ? style.table_hide_content : '')}>
      {todayMatch}
    </div>,
    tomorrowMatch.length > 0 && (
        <div className={clsx(style.sportTypeWrapper, isFinal && style.final, page === 'home' ? style.border_left_right : '')}>
          <h2 className={style.tomorrow}>{tomorrowDate}</h2>
          {tomorrowMatch}
        </div>
    )
  ];
};

export default MajorTimeSortWrapper;
